module.exports = __webpack_public_path__ + "img/articles.fa9660b3.svg";